import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
// import StoreItemImage1 from "./../../../assets/images/store-items/image1.png";

import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import Popup from '../../../../components/Popup';
import init from '../../AccessControl/Check';

import ExampleDineInTemplate from './../../../../sample-csv/dine-in-template.xlsx';
import { MAX_UPLOAD_FILE_SIZE } from "../../../../components/Constants/FileUpload";

const DineInPoint = () => {
    const pageName = "Store Dine In Point";
    const isAccess = init(pageName);


    const [deleteModal, setDeleteModal] = useState({
        isShow: false,
        name: ""
    });

    const [isPopupShow, setIsPopupShow] = useState({
        editInstructions: false
    });

    const [instruction, setInstruction] = useState("");

    const [reqParam, setReqParam] = useState({
        page: 1,
    });

    const closeModel = () => {
        setIsPopupShow({ editInstructions: false, uploadExcel: false });
        setInstruction("");
    }

    const openModel = (id) => {
        switch (id) {
            case "instructions":
                setIsPopupShow({ editInstructions: true });
                break;
            case "upload-excel":
                $(".dropdown-upload-excel ").addClass("hidden");
                setFile();
                setIsPopupShow({ editInstructions: false, uploadExcel: true });
                break;
            default:
                break;
        }
    }


    const showDropDown = event => {
        $(".dropdownDotsHorizontal").hide();
        event.currentTarget.nextSibling.style.display = "block";
    }

    document.addEventListener('scroll', function () {
        $(".dropdownDotsHorizontal").hide();
    }, true);

    $('body').on("click", function (e) {
        if (e.target?.parentElement?.className === "" || e.target?.parentElement?.className === null || e.target?.parentElement?.className === undefined) {
            return;
        }

        if (e.target.parentElement.className.toString().includes("dropdownMenuIconHorizontalButton mt-2") === false) {
            $(".dropdownDotsHorizontal").hide();
        }
    });


    // Get Lists
    const [dineInPoints, setDineInPoints] = useState({
        allow_dine_in: 0,
        dine_in_points: []
    });

    const [apiData, setApiData] = useState({});
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        PostLoginGetApi("store-info/dine-in", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setDineInPoints({ allow_dine_in: responseData["data"]?.allow_dine_in, dine_in_points: JSON.parse(responseData["data"]?.dine_in_points) });
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, [reqParam, refresh]);


    const deleteDineIn = () => {
        PostLoginPostApi("store-info/dine-in/remove", JSON.stringify({ name: deleteModal.name }), 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setRefresh((prev)=>prev += 1);
                    toast.success(responseData.data[0].toString());
                    setDeleteModal({ isShow: false, name: "" });
                    return;
                }

                toast.error(responseData.data[0].toString());
            }
        }).catch((err) => {
            console.log(err);
        });

        return;
    }


    const submitInstructionForm = (event) => {
        event.preventDefault();

        PostLoginPostApi("store-info/dine-in/add", JSON.stringify({ name: instruction }), 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setRefresh((prev)=>prev += 1);
                    toast.success(responseData.data[0].toString());
                    closeModel();
                    return;
                }

                toast.error(responseData.data[0].toString());
            }
        }).catch((err) => {
            console.log(err);
        });


        closeModel();
    }

    const toggleMenu = () => {
        var menu = document.getElementById("dropdown");


        if (menu.classList.contains("hidden")) {
            menu.classList.remove("hidden");
        }
        else {
            menu.classList.add("hidden");
        }
    }

    const fileInput = useRef();
    const [file, setFile] = useState();
    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("application/vnd.")) {
            toast.error("Please upload valid excel");
            return;
        }

        setFile(e.target.files[0]);
    }

    const selectFile = () => {
        fileInput.current.click();
    }


    const submitBulkUploadForm = (event) => {
        event.preventDefault();

        if (file === undefined) {
            toast.error("Please upload excel.");
            return;
        }

        toggleMenu();
        let requestBody = new FormData();
        requestBody.append("excel", file);

        PostLoginPostApi("store-info/dine-in/add-bulk", requestBody, 1, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setRefresh((prev)=>prev += 1);
                    toast.success('Successfully added.');
                    closeModel();
                    return;
                }

                toast.error(responseData.data[0].toString());
            }
        }).catch((err) => {
            console.log(err);
        });


        closeModel();
    }


    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="custom-container w-full font-montserrat flex -mt-4">
            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full mb-20 pb-[100px] pr-3 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] py-3">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5">Here’s your dine in points at a glance</h6>
                        {/* <h5 className="px-4 pb-0 pl-0 pt-2 text-lg font-semibold">Today</h5> */}
                    </div>

                    {(dineInPoints.allow_dine_in === 1) &&
                        <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">
                            <div id="dropdown-wrapper" className="inline-block relative">
                                <button onClick={() => toggleMenu()} className='custom-btn mr-2.5 text-center'>Upload Bulk Dine In Point</button>

                                <div id="dropdown" className="absolute z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-[248px] dark:bg-gray-700">
                                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
                                        <li>
                                            <Link to={ExampleDineInTemplate} download="Example-Dine-In-template" target="_blank"
                                                rel="noreferrer" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Download Sample Excel</Link>
                                        </li>
                                        <li>
                                            <Link onClick={() => openModel("upload-excel")} className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Upload Excel</Link>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <Link to="#" onClick={() => openModel("instructions")} className="custom-btn text-center whitespace-nowrap">Add Dine In Point</Link>
                        </div>
                    }
                </div>

                {/* Model Window */}
                {(isPopupShow.editInstructions === true) &&
                    <div>
                        <Popup is_big={1} content={
                            <form onSubmit={(event) => submitInstructionForm(event)} className="p-5 font-medium">
                                <div className="flex justify-between">
                                    <h3 className="text-xl text-black">Add New Dine In Point</h3>
                                    <CloseBtn className="cursor-pointer" onClick={closeModel} />
                                </div>

                                <input type="text" name="name" id="name" value={instruction} onChange={(event) => setInstruction(event.currentTarget.value)} className='w-full mt-7 mb-5 resize-none border-[#DDD] rounded overflow-hidden focus:outline-none' placeholder="Enter Pickup Point Name *" required />

                                <button type="submit" className="text-white bg-black py-3 text-base rounded cursor-pointer w-full hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-wait">
                                    Save
                                </button>

                            </form>}
                        />
                    </div>
                }

                {/* Model Window - Excel Upload */}
                {(isPopupShow.uploadExcel === true) &&
                    <div>
                        <Popup content={
                            <form onSubmit={(event) => submitBulkUploadForm(event)} className="p-5 font-medium">
                                <div className="flex justify-between">
                                    <h3 className="text-xl text-black">Add Dine In Point as Bulk</h3>
                                    <CloseBtn className="cursor-pointer" onClick={closeModel} />
                                </div>

                                <div className="flex items-center relative w-full bg-[#f5f5f5] p-2 rounded-md mt-12 mb-3" style={{ border: "1px solid #e0e0e0" }}>
                                    <input type="file" name="logo" className="hidden" ref={fileInput} onChange={handleChange} />

                                    {file ?
                                        <>
                                            <span className='text-sm' title={file.name}>
                                                {file.name.toString().substring(0, 28)}
                                                {(file.name.length > 28) && <>...</>}
                                            </span>
                                            <button type="button" className="text-white ml-auto float-right order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change</button>

                                            <button type="submit" className="text-white ml-1 order-3 bg-[#1A202C] py-[10px] px-[10px] rounded-[3px] cursor-pointer block text-xs hover:bg-[#444]">Submit</button>
                                        </> :
                                        <>
                                            <label htmlFor="logo" className="p-1 text-base font-medium">Upload Excel</label>
                                            <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Upload</button>
                                        </>
                                    }
                                </div>


                            </form>}
                        />
                    </div>
                }




                {/* DATA TABLE  */}

                <div className="flex flex-col w-full pt-5">
                    <div className='-m-1.5 pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className='border rounded-lg shadow'>
                                <table className='min-w-full divide-y divide-gray-200 custom-table-hover '>
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left '>
                                            <th scope="col" className="px-6 py-4" colSpan={2}>Dine In Point Name</th>
                                        </tr>
                                    </thead>

                                    <tbody className='divide-y divide-gray-200'>

                                        {(dineInPoints.allow_dine_in === 0) ?
                                            <tr key="0">
                                                <td colSpan={2} className='px-6 py-1 '>
                                                    <p className='py-4'>Dine In mode is disable.</p>
                                                </td>
                                            </tr>

                                            :
                                            <>
                                                {(dineInPoints.dine_in_points.length === 0) &&
                                                    <tr key="0">
                                                        <td colSpan={2} className='px-6 py-1 '>
                                                            <p className='py-4'>No dine in point added</p>
                                                        </td>
                                                    </tr>
                                                }

                                                {dineInPoints.dine_in_points.map((data, index) => (
                                                    <tr key={index}>
                                                        <td className='px-6 py-1 '>{data}</td>
                                                        <td className='px-6 py-1 text-center w-[120px]'>

                                                            <></>
                                                            <button onClick={showDropDown} data-dropdown-toggle="dropdownDotsHorizontal" className="dropdownMenuIconHorizontalButton mt-2">
                                                                <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"></path></svg>
                                                            </button>

                                                            <div className="dropdownDotsHorizontal hidden relative z-50">
                                                                <div className='absolute -ml-20 -mt-2 border border-[1px solid rgb(245, 245, 245)] bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600'>
                                                                    <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
                                                                        <li>
                                                                            <span onClick={() => setDeleteModal({ isShow: true, name: data })} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                Delete
                                                                            </span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {(apiData?.meta?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.meta?.from * 1} - ${apiData?.meta?.to * 1} out of ${apiData?.meta?.total * 1}`}
                                    </p>


                                    {(apiData?.links?.next !== null && apiData?.links?.next !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.links?.prev !== null && apiData?.links?.prev !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5 mr-2">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }




                        </div>
                    </div>
                </div>
            </div>


            {/* Popup */}
            {((deleteModal?.isShow === true) && deleteModal.id !== "") ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            {/*content*/}
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button type="button" onClick={() => setDeleteModal(false)} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <svg aria-hidden="true" className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Are you sure you want to delete this dine-in?</h3>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={deleteDineIn} className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                        Yes, I'm sure
                                    </button>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => setDeleteModal(false)} className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">No, cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}


        </div>
    );
};

export default DineInPoint;